import SimpleBar from 'simplebar';

let size = innerWidth > 1024 ? 85 : 40

export const simplebarInit = () => {
    if (document.body.classList.contains("contact")) {
        document.querySelectorAll(".contact__privacyInnerBlock").forEach((elm) => {
            new SimpleBar(elm, { autoHide: false, scrollbarMaxSize: size, scrollbarMinSize: size, });
        })
    }
}
